import { ArrowRight, Radar } from "lucide-react";
import { Link, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Public chrome for the guides/blog inside the Pro app.
 *
 * Uses the Pro design language (surface/ink/line/brand tokens, rounded corners,
 * soft shadow, theme-aware) so the blog reads as part of the product rather than
 * a separate marketing site.
 */
export function BlogChrome() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-surface-0 text-ink">
      <header className="sticky top-0 z-30 border-b border-line bg-surface-0/85 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
          <Link to="/blog" className="flex items-center gap-2.5">
            <div className="grid h-8 w-8 place-items-center rounded-lg bg-gradient-to-br from-brand to-brand-dim shadow-soft">
              <Radar size={18} className="text-white" />
            </div>
            <span className="text-[15px] font-bold tracking-tight text-ink">
              Biedradar <span className="font-semibold text-ink-muted">Blog</span>
            </span>
          </Link>
          <Link
            to="/"
            className="ring-focus inline-flex items-center whitespace-nowrap gap-1.5 rounded-md bg-brand px-3.5 py-1.5 text-sm font-semibold text-white shadow-soft transition-colors hover:bg-brand-dim"
          >
            {t("blog.backToApp")}
            <ArrowRight size={15} />
          </Link>
        </div>
      </header>
      <Outlet />
    </div>
  );
}
